var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramMarketplace40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Marketplace40",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 11.000000)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 2.11764706,
    y: 2.16,
    width: 19.7647059,
    height: 15.84
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 12,
    y: 10.8,
    width: 2.82352941,
    height: 7.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#FFFFFF",
    x: 4.94117647,
    y: 9.36,
    width: 3.52941176,
    height: 3.6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#FFCC00",
    x: 14.8235294,
    y: 10.8,
    width: 4.94117647,
    height: 7.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,2.16 L4.8,2.16 L4.8,4.8 C4.8,6.1254834 3.7254834,7.2 2.4,7.2 C1.0745166,7.2 1.623249e-16,6.1254834 0,4.8 L0,2.16 L0,2.16 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8,2.16 L9.6,2.16 L9.6,4.8 C9.6,6.1254834 8.5254834,7.2 7.2,7.2 C5.8745166,7.2 4.8,6.1254834 4.8,4.8 L4.8,2.16 L4.8,2.16 Z",
    id: "Rectangle-Copy",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.6,2.16 L14.4,2.16 L14.4,4.8 C14.4,6.1254834 13.3254834,7.2 12,7.2 C10.6745166,7.2 9.6,6.1254834 9.6,4.8 L9.6,2.16 L9.6,2.16 Z",
    id: "Rectangle-Copy-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4,2.16 L19.2,2.16 L19.2,4.8 C19.2,6.1254834 18.1254834,7.2 16.8,7.2 C15.4745166,7.2 14.4,6.1254834 14.4,4.8 L14.4,2.16 L14.4,2.16 Z",
    id: "Rectangle-Copy-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2,2.16 L24,2.16 L24,4.8 C24,6.1254834 22.9254834,7.2 21.6,7.2 C20.2745166,7.2 19.2,6.1254834 19.2,4.8 L19.2,2.16 L19.2,2.16 Z",
    id: "Rectangle-Copy-4",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.82352941,0 L21.1764706,0 C21.5663186,-2.03811942e-15 21.8823529,0.316034294 21.8823529,0.705882353 L21.8823529,2.16 L21.8823529,2.16 L2.11764706,2.16 L2.11764706,0.705882353 C2.11764706,0.316034294 2.43368135,1.82636229e-16 2.82352941,0 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramMarketplace40);
export default __webpack_public_path__ + "static/media/pictogramMarketplace40.b5b97ee370430c1f4c278531b59fb2d3.svg";
export { ForwardRef as ReactComponent };